import { Wrapper } from 'AppReact';
import styled, { css, keyframes } from 'styled-components';

export const grow = (width) => keyframes`
  0% {
    width: 0px;
    overflow: hidden;
  }
  99% {
    overflow: hidden;
    width: ${width};
  }
  100% {
    overflow: unset;
  }
`;

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    flex-direction: column;
    position: absolute;
    height: ${displayState?.height ?? '640px'};
    right: 0px;
    width: ${displayState?.width ?? '300px'};
    background-color: white;
    border-radius: 20px;
    border: 1px solid #E3E3E3;
    bottom: 0px;
    box-shadow: 0px 4px 40px rgba(160, 174, 192, 0.15);
    
    @media only screen and (min-width: 768px) {    
      height: 100%;
      border-radius: 0px 20px 20px 0px;
      border: none;
      border-left: 1px solid #E3E3E3;
      width: ${displayState?.width ?? '395px'};
    }

    @media screen and (min-width: 1280px) {
      left: 100%;
      animation: ${grow(displayState?.width ?? '395px')} 500ms ease-in-out 0s forwards;;  
    }
  `}
`;

export default Wrapper(template);